export const CONTENT_PERIODS = ["days7", "previousWeek", "months1", "months3", "months6", "months12"] as const;
export type ContentPeriod = (typeof CONTENT_PERIODS)[number];
export const DEFAULT_CONTENT_PERIOD: ContentPeriod = "months3";

const DAY_MS = 24 * 60 * 60 * 1000;
const dateKey = (date: Date) => date.toISOString().slice(0, 10);

export const contentAnalyticsPeriod = (
  period: ContentPeriod,
  now = new Date()
): { dateFrom: string; dateTo: string } => {
  const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  let from: Date;
  let to = new Date(today.getTime() - DAY_MS);
  if (period === "previousWeek") {
    const monday = new Date(today.getTime() - ((today.getUTCDay() + 6) % 7) * DAY_MS);
    from = new Date(monday.getTime() - 7 * DAY_MS);
    to = new Date(monday.getTime() - DAY_MS);
  } else if (period === "days7") {
    from = new Date(today.getTime() - 7 * DAY_MS);
  } else {
    const months = Number(period.slice(6));
    from = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - months, 1));
    const lastDay = new Date(Date.UTC(from.getUTCFullYear(), from.getUTCMonth() + 1, 0)).getUTCDate();
    from.setUTCDate(Math.min(today.getUTCDate(), lastDay));
  }
  return { dateFrom: dateKey(from), dateTo: dateKey(to) };
};

export const formatContentDate = (date: string): string => date.slice(0, 10).split("-").reverse().join(".");
